/** The destinations a job can send to, in the words of the Results guide. */
export const destinations: readonly { name: string; gets: string }[] = [
  {
    name: 'Download',
    gets: 'Every job has it: the package, for GET /documents/{documentId}/package/{file}.',
  },
  {
    name: 'Webhook',
    gets: 'A signed POST of document.json and the package links to your https endpoint, per confirmed revision. Added through the API or in Paige.',
  },
  {
    name: 'SFTP',
    gets: 'The PDF in your folder, under the folders and name of the job’s file naming. Added through the API or in Paige.',
  },
  {
    name: 'Microsoft 365, Google Drive, Dropbox, Box',
    gets: 'The PDF filed in the folder you chose, with the fields in the product’s own metadata where it has some. Connected in Paige, by signing in to the provider.',
  },
  {
    name: 'Content Central, Nucleus One',
    gets: 'The PDF filed with the fields as index values. Added through the API or in Paige.',
  },
];

/**
 * A document.json from the run on 2026-10-03 (one page and two fields left out). Its total is written as
 * a job answers it since 2026-10-07, as printed on the page: the run's job had no setup, and such a job
 * is no longer read.
 */
export const packageExample = `{
  "id": "a185de74-c65f-4f84-8654-824aa67821d6",
  "job_id": "9e447cc1-0cb9-4364-9efb-a655da2efe5f",
  "batch_id": "100651ee-e21d-4108-a3d7-d33ac6e6dce6",
  "revision": 1,
  "type": "invoice",
  "state": "accepted",
  "pages": [
    {"id": "bc899827-bfe0-43da-b9a4-91ec70733b76", "source_file": "001_invoice_stark_SI-111765.tif",
     "page_number": 1, "width": 1236, "height": 1600}
  ],
  "fields": [
    {"name": "vendor_name", "value": "HARBOR FREIGHT LINES", "confidence": 0.9998,
     "page_id": "bc899827-bfe0-43da-b9a4-91ec70733b76",
     "evidence": {"x": 0.1383, "y": 0.0481, "width": 0.2549, "height": 0.0225}},
    {"name": "document_number", "value": "SI-111765", "confidence": 0.997,
     "page_id": "bc899827-bfe0-43da-b9a4-91ec70733b76",
     "evidence": {"x": 0.7977, "y": 0.0969, "width": 0.068, "height": 0.0125}},
    {"name": "total_amount", "value": "$207,420.79", "confidence": 0.5}
  ],
  "line_items": [],
  "filed": {"folders": ["invoice"], "name": "invoice_2026-10-04_a185de74", "notes": ["…"]},
  "exported_at": "2026-10-04T00:37:27.2367719+00:00"
}`;
